import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import moment from 'moment';
import { IStore } from 'redux/store';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
	vesselId: string;
	selectedDate?: string;
};
type CompassErrorTeekayCoverPageProps = PropsFromRedux & OwnProps;
function CompassErrorTeekayCoverPage(props: CompassErrorTeekayCoverPageProps) {
	const {
		vesselInfo,
		selectedDate
	} = props;
	const compassErrorData = {
		master: '',
		vesselName: vesselInfo?.vesselName,
	};

	const {
		master,
		vesselName,
	} = compassErrorData;

	return (
		<div>
			{/* First page */}
			<div className="flex flex-col justify-between py-4 px-8 mb-2 print-page-break">
				<div className="font-medium text-center text-xl my-24 mx-0">
					<h2 className="uppercase text-2xl">
						COMPASS Observation Book
					</h2>
				</div>
				<div className="flex justify-center mt-8 mb-32">
					<div className="w-2/3 mt-2.5">
						<div
							className="flex items-center mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<p className="mr-2 min-w-fit mb-0">Vessel:</p>
							<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
								{vesselName}
							</p>
						</div>
						<div
							className="flex items-center mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<p className="mr-2 min-w-fit mb-0">Master:</p>
							<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
								{master}
							</p>
						</div>

						<div
							className="flex justify-between items-center mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<div
								style={{ width: '54%' }}
								className="flex items-center  mb-2"
							>
								<p className="mr-2 min-w-fit">Period From :</p>
								<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
									{selectedDate &&
										moment(selectedDate).format(
											'DD-MM-yyyy'
										)}{' '}
								</p>{' '}
							</div>
							<div
								style={{ width: '45%' }}
								className="flex items-center mb-2"
							>
								<p className="mr-2 min-w-fit">To :</p>
								<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
									{selectedDate &&
										moment(selectedDate).format(
											'DD-MM-yyyy'
										)}
								</p>{' '}
							</div>
						</div>
						<div
							className="flex items-center mb-4"
							style={{ fontSize: '1.125rem' }}
						>
							<p className="mr-2 min-w-fit mb-0">Working language of the ship:</p>
							<p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
								English
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
	const inspectorStore = inspectorSelectors._getStore(store);
	const dateRange = inspectorSelectors.getDateRange(inspectorStore);
	return {
		vesselInfo,
		dateRange,
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(CompassErrorTeekayCoverPage);
